import { SELECT_DROPDOWN_ROLE } from '../../../../constants/select'
import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'
import {
  APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE,
  APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE,
} from '../../../RentalPortalApplicant'

export const APPLICANT_FORM_FIELD_NAME_EMAIL = 'email'

export const APPLICANT_FORM_FIELD_NAME_FIRST_NAME = 'first_name'

export const APPLICANT_FORM_FIELD_NAME_LAST_NAME = 'last_name'

export const APPLICANT_FORM_FIELD_NAME_LISTING = 'listing'

export const APPLICANT_FORM_FIELD_NAME_MESSAGE = 'message'

export const APPLICANT_FORM_FIELD_NAME_PHONE = 'phone'

export const APPLICANT_FORM_INITIAL_VALUES = {
  [APPLICANT_FORM_FIELD_NAME_EMAIL]: FORMIK_EMPTY_VALUE,
  [APPLICANT_FORM_FIELD_NAME_FIRST_NAME]: FORMIK_EMPTY_VALUE,
  [APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE]: null,
  [APPLICANT_FORM_FIELD_NAME_LAST_NAME]: FORMIK_EMPTY_VALUE,
  [APPLICANT_FORM_FIELD_NAME_LISTING]: null,
  [APPLICANT_FORM_FIELD_NAME_MESSAGE]: FORMIK_EMPTY_VALUE,
  [APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE]: null,
  [APPLICANT_FORM_FIELD_NAME_PHONE]: FORMIK_EMPTY_VALUE,
}

export const APPLICANT_FORM_FIELD_ORDER = [
  APPLICANT_FORM_FIELD_NAME_FIRST_NAME,
  APPLICANT_FORM_FIELD_NAME_LAST_NAME,
  APPLICANT_FORM_FIELD_NAME_EMAIL,
  APPLICANT_FORM_FIELD_NAME_PHONE,
  APPLICANT_FORM_FIELD_NAME_LISTING,
  APPLICANT_FORM_FIELD_NAME_MOVE_IN_DATE,
  APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE,
  APPLICANT_FORM_FIELD_NAME_MESSAGE,
]

export const APPLICANT_FORM_OPEN_DROPDOWN_SELECTOR = `[role="${SELECT_DROPDOWN_ROLE}"]`

export const APPLICANT_FORM_MESSAGE_FIELD_MAX_LENGTH = 2000

export const APPLICANT_FORM_MESSAGE_FIELD_MIN_ROWS = 3

export const QA_NAME_APPLICANT_FORM_NO_LISTINGS = 'applicantFormNoListings'
